import React from 'react';
import PropTypes from 'prop-types';

import { PageContext } from '../../../../contexts/ContextCreator';
import CardTitle from '../../../Elements/CardTitle/CardTitle';
import SVGFromCloudinary from '../../../Elements/SVGFromCloudinary/SVGFromCloudinary';
import Button from '../../../Input/Button/Button';
import Pixel, {
    EmitMetric,
} from '../../../Analytics/VisibilityPixel/VisibilityPixel';

import './JobLookingCTA.scss';

export default class JobLookingCTA extends React.PureComponent {
    constructor(props) {
        super(props);
    }

    static contextType = PageContext;

    static propTypes = {
        LAC: PropTypes.string,
        LAT: PropTypes.string,
        clickMetric: PropTypes.string,
        impressionMetric: PropTypes.string,
    };

    static defaultProps = {
        LAC: '',
        LAT: '',
        clickMetric: '',
        impressionMetric: '',
    };

    handleMetricEvent = () => {
        const { clickMetric } = this.props;

        if (clickMetric) {
            EmitMetric({
                misc_event_type: clickMetric,
                misc_event_count: 1,
            });
        }
    };

    getProfileLinkWithLatLac = (lat = '', lac = '') => {
        const baseUrl = '/users/profile';

        if (!lat && !lac) return baseUrl;

        const latParam = `LAT=${lat}`;
        const lacParam = `LAC=${lac}`;

        if (!lat) return `${baseUrl}?${lacParam}`;
        if (!lac) return `${baseUrl}?${latParam}`;

        return `${baseUrl}?${latParam}&${lacParam}`;
    };

    render() {
        const { jobProfileSnippet, featureFlags } = this.context;
        if (jobProfileSnippet.isCompleted || !featureFlags.onSiteCTA) {
            return null;
        }

        const { LAT, LAC, clickMetric, impressionMetric } = this.props;

        const profileLink = this.getProfileLinkWithLatLac(LAT, LAC);

        return (
            <div className="component-CallToAction-OnSiteProfileCTAs-JobLookingCTA">
                {impressionMetric && (
                    <Pixel
                        metrics={{
                            misc_event_type: impressionMetric,
                            misc_event_count: 1,
                        }}
                    />
                )}

                <CardTitle className="cta-title">
                    Looking for a new job?
                </CardTitle>

                <p className="cta-text">
                    Our employer partners are actively recruiting women! Update
                    your profile today.
                </p>

                {this.context.wrapAuth(
                    'OnSite-Profile-CTA',
                    <a href={profileLink} onClick={this.handleMetricEvent}>
                        <Button
                            inputStyle="purple-medium-white"
                            value="Get started"
                            className="view-profile-btn"
                        />
                    </a>,
                    { login_trigger: clickMetric },
                    null,
                    'login',
                    null,
                    profileLink
                )}

                <SVGFromCloudinary
                    cloudinaryID="v1592849999/SVGs/cta-badge.svg"
                    alt="tag with leaves"
                />
            </div>
        );
    }
}
